import { ChangeEvent, useCallback } from "react"
import { FilterItemProps, inputClasses } from "../_common"
import clsx from "clsx"

interface SelectFilterProps<OT> extends FilterItemProps<OT> {
    options: OT[]
    getOptionValue: (option: OT) => string
    renderOptionLabel: (option: OT) => string
}

export function SelectFilter<OT>({
    getOptionValue,
    renderOptionLabel,
    value,
    options,
    name,
    handleChange,
}: SelectFilterProps<OT>) {
    const onChange = useCallback(
        (e: ChangeEvent<HTMLSelectElement>) => {
            const selected = options.find(
                (opt) => getOptionValue(opt) === e.currentTarget.value
            )
            selected && handleChange?.(selected)
        },
        [getOptionValue, handleChange, options]
    )

    return (
        <select
            value={value && getOptionValue(value)}
            id={name}
            name={name}
            className={clsx(inputClasses, 'pr-6')}
            onChange={onChange}
        >
            {options.map((opt) => (
                <option value={getOptionValue(opt)}>{renderOptionLabel(opt)}</option>
            ))}
        </select>
    )
}